export const fbq = (...args) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq(...args);
  }
};

export const trackPageView = () => fbq("track", "PageView");

export const trackViewContent = ({
  content_ids,
  content_name,
  value,
  currency = "EGP",
}) =>
  fbq("track", "ViewContent", {
    content_type: "product",
    content_ids,
    content_name,
    value,
    currency,
  });

export const trackAddToCart = ({
  content_ids,
  content_name,
  value,
  currency = "EGP",
}) =>
  fbq("track", "AddToCart", {
    content_type: "product",
    content_ids,
    content_name,
    value,
    currency,
  });

export const trackInitiateCheckout = ({
  value,
  currency = "EGP",
  num_items,
  content_ids,
}) =>
  fbq("track", "InitiateCheckout", {
    value,
    currency,
    num_items,
    ...(content_ids ? { content_ids } : {}),
  });

export const trackPurchase = ({
  value,
  currency = "EGP",
  num_items,
  content_ids,
}) =>
  fbq("track", "Purchase", {
    value,
    currency,
    num_items,
    ...(content_ids ? { content_ids } : {}),
  });
export const trackAddPaymentInfo = () => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "AddPaymentInfo");
  }
};
